var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_6f63e5a9"]},_vm.$listeners),[_c('div',{class:["button-groupwith-context-demo"]},[_c('cube-button-group',{attrs:{"direction":"horizontal"}},[_c('div',{class:["button-groupwith-title"]},[_vm._v("图文结合示例")]),_c('cube-button',{attrs:{"inline":""}},[_vm._v("操作")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }